import React, { useState, useEffect } from 'react';
import '../styles.css';
import HeaderTotal from './header_total';
import { ReactComponent as WaitIcon } from '../assets/wait.svg'

const FormularioContacto = ({ onContinuar, onEnviarFinal, enviando, errorEnvio, datos }) => {
  //console.log(address)

  const [contacto, setContacto] = useState({
    nombre: '',
    apellidos: '',
    correo: '',
    telefono: '',
    aceptaTerminos: '',
  });



  const [errores, setErrores] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (errores[name]) {
      setErrores(prevErrores => {
        const nuevosErrores = { ...prevErrores };
        delete nuevosErrores[name];
        return nuevosErrores;
      });
    }


    setContacto({
      ...contacto,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const validarFormulario = () => {
    let erroresTemp = {};
    const regexCorreo = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const regexTelefono = /^\d{10}$/; // Valida 10 dígitos (ej. 5555555555)

    if (!contacto.nombre) {
      erroresTemp.nombre = 'El nombre es obligatorio.';
    }
    if (!regexCorreo.test(contacto.correo)) {
      erroresTemp.correo = 'El correo electrónico no es válido.';
    }
    if (!regexTelefono.test(contacto.telefono)) {
      erroresTemp.telefono = 'El teléfono debe tener 10 dígitos.';
    }
    if (!contacto.aceptaTerminos) {
      erroresTemp.aceptaTerminos = 'Debes aceptar los términos y condiciones.';
    }

    setErrores(erroresTemp);
    return Object.keys(erroresTemp).length === 0;
  };

 

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validarFormulario()) {
      // 1) guarda en App
      await onEnviarFinal({ contacto: contacto });  // 2) envía payload completo
      //onContinuar({ contacto: contacto });  
    } else {
      //console.log('El formulario tiene errores.');
    }
  };

  return (
    <div className="contenedor-formulario">
      {!enviando &&<HeaderTotal total="" />}
      {!enviando &&
        <form onSubmit={handleSubmit} className="formulario-rotoplas">
          <h2 className="titulo-seccion">Datos de contacto</h2>

          <div className="grupo-input">
            <label htmlFor="nombre">Nombre</label>
            <input
              type="text"
              id="nombre"
              name="nombre"
              value={contacto.nombre}
              onChange={handleChange}
              placeholder="Nombre*"
            />
            {errores.nombre && <p className="mensaje-error">{errores.nombre}</p>}
          </div>

          <div className="grupo-input">
            <label htmlFor="apellidos"></label>
            <input
              type="text"
              id="apellidos"
              name="apellidos"
              value={contacto.apellidos}
              onChange={handleChange}
              placeholder="Apellidos*"
            />
          </div>

          <div className="grupo-input">
            <label htmlFor="correo">Correo:</label>
            <input
              type="email"
              id="correo"
              name="correo"
              value={contacto.correo}
              onChange={handleChange}
              placeholder="Correo electrónico*"
            />
            {errores.correo && <p className="mensaje-error">{errores.correo}</p>}

          </div>

          <div className="grupo-input">
            <label htmlFor="telefono">Teléfono:</label>
            <input
              type="tel"
              id="telefono"
              name="telefono"
              value={contacto.telefono}
              onChange={handleChange}
              placeholder="Teléfono de contacto*"
            />
            {errores.telefono && <p className="mensaje-error">{errores.telefono}</p>}
          </div>

          <div className="terminos-condiciones">
            <input
              type="checkbox"
              id="aceptaTerminos"
              name="aceptaTerminos"
              checked={contacto.aceptaTerminos}
              onChange={handleChange}
            />
            <label htmlFor="aceptaTerminos">
              Acepto los <a href="http://35.190.6.174/Terminos_y_condiciones/20252705_Te%CC%81rminos%20y%20condicones_%20Entrega%20ra%CC%81pi%CC%81da_v1.0.pdf"
                target="_blank" rel="noopener noreferrer">Términos y condiciones</a> y{' '}
              <a href="https://rotoplas.com.mx/aviso-de-privacidad/" target="_blank" rel="noopener noreferrer">
                Aviso de privacidad</a>
            </label>
          </div>
          {errores.aceptaTerminos && <p className="mensaje-error">{errores.aceptaTerminos}</p>}

          <button type="submit" className="boton-next" disabled={enviando}>
            {enviando ? "Enviando..." : "Agregar datos de pago"}
          </button>


          {errorEnvio && <p className="mensaje-error">{errorEnvio}</p>}

        </form>
      }
      {enviando &&
        <div className="grupo-input">
          <h2 className="titulo-seccion" style={{ textAlign: 'center' }}>Preparando todo para procesar el pago😃</h2>
          <br></br>
          <div style={{
            display: 'flex',
            justifyContent: 'center', /* Centra horizontalmente */
            alignItems: 'center', /* Centra verticalmente */
            
          }}>
            <WaitIcon style={{
              width: '25%', /* 25% del ancho del contenedor (100vw) */
              height: '25%', /* 25% del alto del contenedor (100vh) */
            }} />
          </div>
          <br></br>
          <h2 className='titulo-wait'>Por favor, espera un momento.</h2>

        </div>

      }
    </div>
  );
};

export default FormularioContacto;